var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsDateString } from 'class-validator';
export class CreateD2CRefundPolicyDateRangeDto {
}
__decorate([
    IsDateString({}, { message: '날짜 형식이 올바르지 않습니다.' }),
    __metadata("design:type", String)
], CreateD2CRefundPolicyDateRangeDto.prototype, "startDate", void 0);
__decorate([
    IsDateString({}, { message: '날짜 형식이 올바르지 않습니다.' }),
    __metadata("design:type", String)
], CreateD2CRefundPolicyDateRangeDto.prototype, "endDate", void 0);
